import { Box } from "@husqvarna/ui-core";
import clsx from "clsx";
import { useIntl } from "react-intl";
import "./ColorTile.scss";

interface ColorTileProps {
  color: string;
  size?: "small" | "medium" | "large";
}

const ColorTile = ({ color, size = "small" }: ColorTileProps) => {
  const intl = useIntl();
  const width = size === "small" ? 3 : size === "medium" ? 4 : 5;
  const ariaLabel = intl.formatMessage({ id: `color.${color}` });
  
  return (
    <Box 
      component="span" 
      ml={2} 
      width={width} 
      height={width} 
      br={1} 
      className={clsx("color-tile", `color-tile--${color}`)}
      aria-label={ariaLabel}
    />
  )
}

export default ColorTile;